import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquareIcon } from 'lucide-react';
import type { RepPromptContent } from '../../types/snak';
interface RepPromptProps {
  prompt: RepPromptContent;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function RepPrompt({
  prompt
}: RepPromptProps) {
  return <motion.aside initial={{
    opacity: 0,
    y: 6
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.22,
    ease: EASE
  }} aria-label="Rep prompt" className="flex max-w-2xl flex-1 items-start gap-3.5 rounded-2xl bg-navy px-5 py-3.5" data-id="element-211" data-mp="s2sh7jm04tsl">
      <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-mint/20" data-id="element-212" data-mp="16z9pg1yw9sax">
        <MessageSquareIcon className="h-3.5 w-3.5 text-mint" aria-hidden="true" data-id="element-213" data-mp="1b03e4xk5vb4v" />
      </span>
      <div className="min-w-0" data-id="element-214" data-mp="1yqfumwth2g72">
        <p className="text-[9px] uppercase tracking-micro text-mint" data-id="element-215" data-mp="1ype73sv9s18g">Rep prompt · not shown to HCP</p>
        <div className="mt-1 space-y-0.5" data-id="element-216" data-mp="23hphxqrjt7fs">
          {prompt.say.map(line => <p key={line} className="text-[13px] leading-snug text-paper" data-id="element-217" data-mp="1feil0q22g35v">
              {line}
            </p>)}
        </div>
        {prompt.avoid && <p className="mt-1.5 text-[11px] leading-snug text-sky/60" data-id="element-218" data-mp="1p53k0elnj9pb">{prompt.avoid}</p>}
      </div>
    </motion.aside>;
}